import { findErrorMessage } from '@astlai/common/util/error-handling/find-error-message';

/**
 * Converts an unknown thrown value into a proper Error instance.
 * If already an Error, returns it as-is. Otherwise creates an Error
 * with an extracted message and attaches the original value as `cause`.
 */
export function toError(err: unknown): Error {
  if (err instanceof Error) return err;
  const message = findErrorMessage(err) ?? "Unknown error";
  const error = new Error(message);
  error.cause = err;
  return error;
}
